<template>
  <div class="feed-title-container flex">
    <div class="feed-title ellipsis">{{ initFeedTitle }}</div>
    <div class="feed-info-wrapper">
      <div class="feed-status-container">
        <span :class="initIsShow">系统屏蔽</span>
        <span :class="initCanShared">系统限制分享</span>
        <span :class="initSharePublic">社区</span>
        <span :class="initShareFriend">小区</span>
        <span :class="initShareClan">族窗</span>
        <span :class="initHidden">隐藏</span>
      </div>
      <div>
        <span>{{ initDate }}</span>
        <el-dropdown
          placement="bottom"
          trigger="click"
          @command="handleAcation"
        >
          <span class="arrow-down-wrapper">
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="1">编辑</el-dropdown-item>
            <el-dropdown-item :command="2">删除</el-dropdown-item>
            <el-dropdown-item :command="3" v-if="feed.isHidden == 1"
              >取消隐藏</el-dropdown-item
            >
            <el-dropdown-item
              :command="4"
              v-if="feed.isStoraged == 1 && feed.isHidden !== 1"
              >隐藏</el-dropdown-item
            >
            <el-dropdown-item
              :command="5"
              v-if="shareAbility && feed.sharePublic == 1"
              >从社区撤回</el-dropdown-item
            >
            <el-dropdown-item
              :command="6"
              v-if="shareAbility && feed.sharePublic == 0"
              >分享到社区</el-dropdown-item
            >
            <el-dropdown-item
              :command="7"
              v-if="shareAbility && feed.shareFriends == 1"
              >从小区撤回</el-dropdown-item
            >
            <el-dropdown-item
              :command="8"
              v-if="shareAbility && feed.shareFriends == 0"
              >分享到小区</el-dropdown-item
            >
            <el-dropdown-item
              :command="9"
              v-if="shareAbility && feed.shareFamily == 1"
              >从族窗撤回</el-dropdown-item
            >
            <el-dropdown-item
              :command="10"
              v-if="
                shareAbility &&
                  (feed.shareFamily == 0 || feed.shareFamily == null)
              "
              >分享到族窗</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { getFullDate } from "../../../utils/date";
import { htmlFilter } from "../../../utils/feed";
import { apiMap } from "../../../utils/apiMap";
export default {
  name: "feed-header",
  props: {
    feed: {
      type: Object,
      required: true,
    },
    feedType: {
      type: String,
      required: true,
    },
  },
  data() {
    if (this.feed.canShared == 0 || this.feed.isShow == 0) {
      return {
        shareAbility: false,
      };
    } else if (["3", "4"].includes(this.feedType)) {
      //音频 & 视频暂不提供 分享菜单
      return {
        shareAbility: false,
      };
    } else {
      return {
        shareAbility: true,
      };
    }
  },
  computed: {
    initDate() {
      return getFullDate(new Date(this.feed.created_at * 1000));
    },
    initFeedTitle() {
      return htmlFilter(this.feed.title);
    },
    initHidden() {
      if (this.feed.isHidden == 1) {
        return "is-active";
      } else {
        return "";
      }
    },
    initCanShared() {
      if (this.feed.canShared == 0) {
        return "is-limiting";
      } else {
        return "is-free";
      }
    },
    initIsShow() {
      if (this.feed.isShow == 0) {
        return "is-limiting";
      } else {
        return "is-free";
      }
    },
    initShareFriend() {
      if (this.feed.canShared == 0 || this.feed.isShow == 0) {
        return "is-free";
      } else {
        if (this.feed.shareFriends == 1) {
          return "is-shared";
        }
      }
    },
    initSharePublic() {
      if (this.feed.canShared == 0 || this.feed.isShow == 0) {
        return "is-free";
      } else {
        if (this.feed.sharePublic == 1) {
          return "is-shared";
        }
      }
    },
    initShareClan() {
      if (this.feed.canShared == 0 || this.feed.isShow == 0) {
        return "is-free";
      } else {
        if (this.feed.shareFamily == 1) {
          return "is-shared";
        }
      }
    },
  },
  methods: {
    handleAcation(action) {
      switch (action) {
        case 1:
          this.reEditProdution();
          break;
        case 2:
          this.removeProduction();
          break;
        case 3:
        case 4:
          this.initHiddenProduction(action);
          break;
        case 5:
        case 6:
          this.initShareToPublic(action);
          break;
        case 7:
        case 8:
          this.initShareToFriend(action);
          break;
        case 9:
        case 10:
          this.initShareToClan(action);
          break;
      }
    },
    reEditProdution() {
      switch (this.feedType) {
        case "1":
          //编辑文章
          this.$bus.$emit("edit-article", this.feed.id);
          break;
        case "2":
          //编辑相册
          this.$bus.$emit("edit-album", this.feed.id);
          break;
        case "3":
          //编辑音频
          this.$bus.$emit("edit-audio", this.feed.id);
          break;
        case "4":
          //编辑视频
          this.$bus.$emit("edit-video", this.feed.id);
          break;
      }
    },
    removeProduction() {
      let _this = this;
      var confirmText = `确定删除《 ${this.feed.title} 》吗？`;
      _this
        .$confirm(confirmText, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info",
          closeOnClickModal: false,
        })
        .then(() => {
          var queryUrl = "";
          var queryMehod = "";
          var queryParams = "";
          let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
          switch (_this.feedType) {
            case "1":
              queryMehod = apiMap["removeArticle"]["method"];
              queryUrl = apiMap["removeArticle"]["url"];
              queryParams = `token=${loginUser.token}&articleIds=${_this.feed.id}`;
              break;
            case "2":
              queryMehod = apiMap["removeAlbum"]["method"];
              queryUrl = apiMap["removeAlbum"]["url"];
              queryParams = `token=${loginUser.token}&photoId=${_this.feed.id}`;
              break;
            case "3":
              queryMehod = apiMap["removeAudio"]["method"];
              queryUrl = apiMap["removeAudio"]["url"];
              queryParams = `token=${loginUser.token}&musicId=${_this.feed.id}`;
              break;
            case "4":
              queryMehod = apiMap["removeVideo"]["method"];
              queryUrl = apiMap["removeVideo"]["url"];
              queryParams = `token=${loginUser.token}&videoId=${_this.feed.id}`;
              break;
          }

          _this
            .$axios({
              baseURL: apiMap["commonUrl"],
              method: queryMehod,
              url: queryUrl,
              data: queryParams,
            })
            .then(function(response) {
              if (response.data.result.statusCode == 1) {
                _this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 1500,
                  offset: 230,
                });
                _this.emitReloadList();
              } else {
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    initHiddenProduction(action) {
      if (action == 4) {
        var confirmText = `如果在家谱中于自己名下暂不想展示该作品，\n或者需在家谱中于某个亲人名下添加此作品，\n请使用该功能`;
        this.$confirm(confirmText, {
          confirmButtonText: "确定隐藏",
          cancelButtonText: "不隐藏",
          closeOnClickModal: false,
          showClose: false,
          customClass: "cl-hide-production",
        }).then(() => {
          this.hiddenProduction(1); //隐藏
        });
      } else {
        this.hiddenProduction(2); //取消隐藏
      }
    },
    hiddenProduction(type) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["hiddenProduction"]["method"],
          url: apiMap["hiddenProduction"]["url"],
          data: `token=${loginUser.token}&modelId=${_this.feed.id}&modelType=${_this.feedType}&hidden=${type}`,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              offset: 230,
            });
            _this.emitReloadList();
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initShareToPublic(type) {
      var queryUrl = "";
      var queryMehod = "";
      var queryParams = "";
      let _this = this;
      var share = null;
      if (type == 5) {
        share = 0;
      } else {
        share = 1;
      }
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      switch (_this.feedType) {
        case "1":
          queryMehod = apiMap["articleShare"]["method"];
          queryUrl = apiMap["articleShare"]["url"];
          queryParams = `token=${loginUser.token}&articleId=${_this.feed.id}&shareField=sharePublic&shareValue=${share}`;
          break;
        case "2":
          queryMehod = apiMap["albumShare"]["method"];
          queryUrl = apiMap["albumShare"]["url"];
          queryParams = `token=${loginUser.token}&photoId=${_this.feed.id}&shareField=sharePublic&shareValue=${share}`;
          break;
        case "3":
          queryMehod = apiMap["musicShare"]["method"];
          queryUrl = apiMap["musicShare"]["url"];
          queryParams = `token=${loginUser.token}&musicId=${_this.feed.id}&shareField=sharePublic&shareValue=${share}`;
          break;
        case "4":
          queryMehod = apiMap["videoShare"]["method"];
          queryUrl = apiMap["videoShare"]["url"];
          queryParams = `token=${loginUser.token}&videoId=${_this.feed.id}&shareField=sharePublic&shareValue=${share}`;
          break;
      }
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: queryMehod,
          url: queryUrl,
          data: queryParams,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.emitReloadList();
          }
          _this.initShareTip(response.data.result.statusCode);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initShareToFriend(type) {
      var queryUrl = "";
      var queryMehod = "";
      var queryParams = "";
      let _this = this;
      var share = null;
      if (type == 7) {
        share = 0;
      } else {
        share = 1;
      }
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      switch (_this.feedType) {
        case "1":
          queryMehod = apiMap["articleShare"]["method"];
          queryUrl = apiMap["articleShare"]["url"];
          queryParams = `token=${loginUser.token}&articleId=${_this.feed.id}&shareField=shareFriends&shareValue=${share}`;
          break;
        case "2":
          queryMehod = apiMap["albumShare"]["method"];
          queryUrl = apiMap["albumShare"]["url"];
          queryParams = `token=${loginUser.token}&photoId=${_this.feed.id}&shareField=shareFriends&shareValue=${share}`;
          break;
        case "3":
          queryMehod = apiMap["musicShare"]["method"];
          queryUrl = apiMap["musicShare"]["url"];
          queryParams = `token=${loginUser.token}&musicId=${_this.feed.id}&shareField=shareFriends&shareValue=${share}`;
          break;
        case "4":
          queryMehod = apiMap["videoShare"]["method"];
          queryUrl = apiMap["videoShare"]["url"];
          queryParams = `token=${loginUser.token}&videoId=${_this.feed.id}&shareField=shareFriends&shareValue=${share}`;
          break;
      }
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: queryMehod,
          url: queryUrl,
          data: queryParams,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.emitReloadList();
          }
          _this.initShareTip(response.data.result.statusCode);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initShareToClan(type) {
      var queryUrl = "";
      var queryMehod = "";
      var queryParams = "";
      let _this = this;
      var share = null;
      if (type == 9) {
        share = 0;
      } else {
        share = 1;
      }
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      switch (_this.feedType) {
        case "1":
          queryMehod = apiMap["articleShare"]["method"];
          queryUrl = apiMap["articleShare"]["url"];
          queryParams = `token=${loginUser.token}&articleId=${_this.feed.id}&shareField=shareFamily&shareValue=${share}`;
          break;
        case "2":
          queryMehod = apiMap["albumShare"]["method"];
          queryUrl = apiMap["albumShare"]["url"];
          queryParams = `token=${loginUser.token}&photoId=${_this.feed.id}&shareField=shareFamily&shareValue=${share}`;
          break;
        case "3":
          queryMehod = apiMap["musicShare"]["method"];
          queryUrl = apiMap["musicShare"]["url"];
          queryParams = `token=${loginUser.token}&musicId=${_this.feed.id}&shareField=shareFamily&shareValue=${share}`;
          break;
        case "4":
          queryMehod = apiMap["videoShare"]["method"];
          queryUrl = apiMap["videoShare"]["url"];
          queryParams = `token=${loginUser.token}&videoId=${_this.feed.id}&shareField=shareFamily&shareValue=${share}`;
          break;
      }
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: queryMehod,
          url: queryUrl,
          data: queryParams,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.emitReloadList();
          }
          _this.initShareTip(response.data.result.statusCode);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initShareTip(result) {
      if (
        this.feed.sharePublic == 1 ||
        this.feed.shareFriends == 1 ||
        this.feed.shareFamily == 1
      ) {
        var tipMsg = {
          duration: 1500,
          offset: 230,
        };
        if (result == 1) {
          tipMsg.message = "操作成功";
          tipMsg.type = "success";
        } else {
          tipMsg.message = "操作失败，稍后再试";
        }
        this.$message(tipMsg);
      } else {
        this.$alert("审核通过后立即发布", "内容审核中", {
          confirmButtonText: "知道了",
          callback: (action) => {},
        });
      }
    },
    emitReloadList() {
      switch (this.feedType) {
        case "1":
          this.$bus.$emit("reload-article-list");
          break;
        case "2":
          this.$bus.$emit("reload-album-list");
          break;
        case "3":
          this.$bus.$emit("reload-audio-list");
          break;
        case "4":
          this.$bus.$emit("reload-video-list");
          break;
      }
    },
  },
};
</script>
<style scoped>
.feed-title-container {
  justify-content: space-between;
}

.feed-title {
  max-width: 335px;
  line-height: 30px;
  font-weight: bold;
  font-size: 16px;
}

.feed-info-wrapper {
  width: 458px;
  display: flex;
  line-height: 30px;
  justify-content: space-between;
}

.feed-status-container {
  font-size: 12px;
}

.feed-status-container span {
  padding: 1px 2px;
  margin: 0 3px;
  color: #d9d9d9;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
}

.feed-status-container .is-active,
.feed-status-container .is-shared {
  color: #1a70db;
  border-color: #1a70db;
}

.feed-status-container .is-limiting {
  color: #ff9800;
  border-color: #ff9800;
}

.feed-status-container .is-free {
  display: none;
}

.arrow-down-wrapper {
  width: 45px;
  height: 25px;
  display: inline-block;
  text-align: center;
  font-size: 17px;
  cursor: pointer;
}

.arrow-down-wrapper:hover {
  color: #ff6600;
}
</style>
